/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_Comparison_Nopreviousdescription2Inputs */

const id_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini adalah build pertama yang dapat dibandingkan dan diamati di stream ini. Anda tetap dapat memeriksa semua file manifest.`)
};

const ms_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini ialah binaan pertama yang boleh dibandingkan dan diperhatikan dalam strim ini. Anda masih boleh memeriksa semua fail manifes.`)
};

const da_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette er det første sammenlignelige build, der er observeret i denne strøm. Du kan stadig undersøge alle manifestfiler.`)
};

const de_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies ist der erste vergleichbare Build, der in diesem Stream beobachtet wurde. Du kannst weiterhin alle Manifestdateien untersuchen.`)
};

const en_us2_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is the first comparable build observed in this stream. You can still inspect all manifest files.`)
};

const es_es2_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es la primera compilación comparable observada en este canal. Aun así puedes consultar todos los archivos del manifiesto.`)
};

const es_mx2_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es la primera compilación comparable observada en este canal. Aun así puedes consultar todos los archivos del manifiesto.`)
};

const fil_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ito ang unang maihahambing na build na naobserbahan sa stream na ito. Maaari mo pa ring suriin ang lahat ng manifest file.`)
};

const fr_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il s’agit du premier build comparable observé dans ce flux. Vous pouvez tout de même examiner tous les fichiers du manifeste.`)
};

const it_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa è la prima build confrontabile osservata in questo flusso. Puoi comunque esaminare tutti i file del manifest.`)
};

const hu_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez az első összehasonlítható build, amelyet ebben az adatfolyamban megfigyeltek. Ettől még megvizsgálhatod az összes manifestfájlt.`)
};

const nl_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit is de eerste vergelijkbare build die in deze stream is waargenomen. Je kunt nog steeds alle manifestbestanden bekijken.`)
};

const no_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette er den første sammenlignbare builden som er observert i denne strømmen. Du kan fortsatt undersøke alle manifestfiler.`)
};

const pl_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To pierwszy porównywalny build zaobserwowany w tym strumieniu. Nadal możesz sprawdzić wszystkie pliki manifestu.`)
};

const pt_br2_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este é o primeiro build comparável observado neste fluxo. Ainda é possível inspecionar todos os arquivos do manifesto.`)
};

const pt_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é a primeira compilação comparável observada neste fluxo. Ainda pode consultar todos os ficheiros do manifesto.`)
};

const ro_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acesta este primul build comparabil observat în acest flux. Poți inspecta în continuare toate fișierele manifestului.`)
};

const fi_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä on ensimmäinen tässä streamissa havaittu vertailukelpoinen build. Voit silti tarkastella kaikkia manifestitiedostoja.`)
};

const sv_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Det här är den första jämförbara builden som observerats i den här strömmen. Du kan fortfarande granska alla manifestfiler.`)
};

const vi_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là build đầu tiên có thể so sánh được quan sát trong luồng này. Bạn vẫn có thể kiểm tra mọi tệp manifest.`)
};

const tr_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu akışta gözlemlenen ilk karşılaştırılabilir derleme budur. Yine de tüm manifest dosyalarını inceleyebilirsiniz.`)
};

const cs_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toto je první porovnatelný build zaznamenaný v tomto streamu. Stále můžete prohlédnout všechny soubory manifestu.`)
};

const bg_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Това е първата сравнима компилация, наблюдавана в този поток. Все още можете да прегледате всички файлове на манифеста.`)
};

const ru_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это первая доступная для сравнения сборка, обнаруженная в этом потоке. Вы по-прежнему можете просмотреть все файлы манифеста.`)
};

const uk_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Це перший порівнюваний білд, який спостерігався в цьому потоці. Ви все одно можете переглянути всі файли маніфесту.`)
};

const ar_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا أول بناء قابل للمقارنة تتم ملاحظته في هذا المسار. لا يزال بإمكانك فحص جميع ملفات البيان.`)
};

const hi_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इस स्ट्रीम में देखा गया यह पहला तुलनीय बिल्ड है। फिर भी आप सभी मेनिफ़ेस्ट फ़ाइलों का निरीक्षण कर सकते हैं।`)
};

const th_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นี่คือบิลด์แรกที่เปรียบเทียบได้ซึ่งพบในสตรีมนี้ คุณยังตรวจสอบไฟล์แมนิเฟสต์ทั้งหมดได้`)
};

const ja_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このストリームで観測された、比較可能な最初のビルドです。すべてのマニフェストファイルは引き続き確認できます。`)
};

const zh_cn2_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是在此数据流中观察到的第一个可比较构建。你仍然可以查看所有清单文件。`)
};

const zh_hant1_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是此串流中觀察到的第一個可比較組建。你仍然可以檢視所有資訊清單檔案。`)
};

const ko_builds_comparison_nopreviousdescription2 = /** @type {(inputs: Builds_Comparison_Nopreviousdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이 스트림에서 관찰된 첫 번째 비교 가능한 빌드입니다. 모든 매니페스트 파일은 계속 확인할 수 있습니다.`)
};

/**
* | output |
* | --- |
* | "This is the first comparable build observed in this stream. You can still inspect all manifest files." |
*
* @param {Builds_Comparison_Nopreviousdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_comparison_nopreviousdescription2 = /** @type {((inputs?: Builds_Comparison_Nopreviousdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_Comparison_Nopreviousdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "ms") return ms_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "da") return da_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "de") return de_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "en-US") return en_us2_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "es-ES") return es_es2_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "es-MX") return es_mx2_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "fil") return fil_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "fr") return fr_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "it") return it_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "hu") return hu_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "nl") return nl_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "no") return no_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "pl") return pl_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "pt") return pt_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "ro") return ro_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "fi") return fi_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "sv") return sv_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "vi") return vi_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "tr") return tr_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "cs") return cs_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "bg") return bg_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "ru") return ru_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "uk") return uk_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "ar") return ar_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "hi") return hi_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "th") return th_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "ja") return ja_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_comparison_nopreviousdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_comparison_nopreviousdescription2(inputs)
	return ko_builds_comparison_nopreviousdescription2(inputs)
});
export { builds_comparison_nopreviousdescription2 as "builds.comparison.noPreviousDescription" }